import styled from 'styled-components';
import { genericBorder } from 'assets/styles/utils';
import { IRON, WHITE } from 'constants/colors';

const Panel = styled.section`
  position: relative;
  display: flex;
  flex-direction: column;
  border: ${genericBorder(IRON)};
  border-radius: 0.25rem;
  box-sizing: border-box;
  background-color: ${WHITE};
  width: ${({ width }) => width || '100%'};
  max-width: ${({ maxWidth }) => (maxWidth || '100%')};
  min-width: ${({ minWidth }) => (minWidth || '0')};
  max-height: ${({ maxHeight }) => (maxHeight || '100%')};
  min-height: ${({ minHeight }) => (minHeight || '0')};
  padding: ${({ padding }) => (padding || '0')};
  margin: ${({ margin }) => (margin || '0')};
  overflow: ${({ overflow }) => (overflow || 'auto')};
  ${({ height }) => height && `
    height: ${height};
  `}
`;

const PanelTitle = styled.h3`
  display: flex;
  align-items: center;
  font-weight: normal;
  line-height: normal;
  padding: ${({ padding }) => (padding || '0')};
  > span {
    font-size: inherit;
  }
  > * {
    margin-right: 0.5rem;

    &:last-child {
      margin-right: 0;
    }
  }
`;

const PanelDescription = styled.span`
  padding: ${({ padding }) => (padding || '0')};
`;

export default Panel;

export { PanelTitle, PanelDescription };
